import axios from 'axios';
import type { TaskPlanDetail } from '../types/engineering';

const BASE = `${import.meta.env.APP_BASE_API_URL}/api/plans`;

export const plansApi = {
  listByTask: (taskId: string): Promise<TaskPlanDetail[]> =>
    axios.get<TaskPlanDetail[]>(`${BASE}/task/${taskId}`).then((r) => r.data),

  approve: (id: string, approved: boolean): Promise<TaskPlanDetail> =>
    axios.patch<TaskPlanDetail>(`${BASE}/${id}/approve`, { approved }).then((r) => r.data),

  updateDescription: (id: string, executionPlan: string): Promise<TaskPlanDetail> =>
    axios.patch<TaskPlanDetail>(`${BASE}/${id}/description`, { executionPlan }).then((r) => r.data),
};
